module.exports = __webpack_public_path__ + "img/go.4aca8733.png";